type StandingOperation = 'federations' | 'competitions' | 'seasons' | 'teams' | 'players'

async function requestStandingData<T>(operation: StandingOperation, payload: Record<string, unknown>): Promise<T> {
    const response = await fetch('/api/standing-stat-data', {
        method: 'POST',
        headers: { 'content-type': 'application/json' },
        credentials: 'same-origin',
        cache: 'no-store',
        body: JSON.stringify({ operation, ...payload })
    })

    const result = (await response.json().catch(() => null)) as { data?: T; error?: string } | null
    if (!response.ok) throw new Error(result?.error || `Standing statistics request failed (${response.status})`)
    return result?.data as T
}

export function fetchOrganisationFederations(orgId: string, filters?: IFederationFilters): Promise<IFederation[]> {
    return requestStandingData('federations', { orgId, filters })
}

export function fetchOrganisationCompetitions(
    orgId: string,
    filters?: IOrganisationDataFilters
): Promise<ICompetition[]> {
    return requestStandingData('competitions', { orgId, filters })
}

export function fetchCompetitionSeasons(competitionId: string): Promise<ISeason[]> {
    return requestStandingData('seasons', { competitionId })
}

export function fetchOrgTopTeams(filters: ITopRankFilter): Promise<ITopTeamStats[]> {
    return requestStandingData('teams', { filters })
}

export function fetchOrgTopPlayers(filters: ITopRankFilter): Promise<ITopPlayerStats[]> {
    return requestStandingData('players', { filters })
}
